<template>
  <div class="slot-slider-line">
    <div
      :class="
        'slot-slider-title game-mml block game-mml-' + category?.slug + (!!category.icon ? ' game-mml-with-icon' : '')
      "
    >
      <img :src="category.icon" :alt="category.title" class="icon" v-if="!!category.icon" />
      <span>{{ category.title }}</span>
      <router-link v-if="isTopic" :to="{ name: 'topics' }" class="all-vendor theme">Все темы </router-link>
      <router-link v-else :to="{ name: 'vendor' }" class="all-vendor">Все провайдеры </router-link>
    </div>

    <div class="slider-games">
      <div v-for="game in games" :key="game.id">
        <game-block :game="game" />
      </div>
    </div>
  </div>
</template>

<script>
import GameBlock from '@/components/GameBlock'
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'

export default {
  name: 'GameListNoSlider',
  props: {
    manufacturer: {},
    category: {},
    games: Array,
    slideperview: {
      type: Number,
      default: 8,
    },
  },
  setup() {
    const { t } = useI18n()

    const slider = ref(null)

    const onSwiper = swiper => {
      slider.value = swiper
    }

    return { t, onSwiper, slider }
  },
  computed: {
    isTopic() {
      return this.$route.name === 'category-topic'
    },
  },
  components: {
    Swiper,
    SwiperSlide,
    GameBlock,
  },
}
</script>

<style scoped>
.slider-games {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -6px;
}
.slider-games > div {
  margin: 0 6px;
}
</style>
